(() => {
  const $ = (s, root = document) => root.querySelector(s);
  const $$ = (s, root = document) => [...root.querySelectorAll(s)];

  async function getCart() {
    const r = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    return r.json();
  }

  async function addToCart(id, quantity = 1, properties = {}) {
    const r = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id, quantity, properties }] })
    });
    if (!r.ok) throw new Error('Unable to add item');
    return r.json();
  }

  async function updateCartCount() {
    try {
      const cart = await getCart();
      $$('.rd-cart__count').forEach(el => el.textContent = cart.item_count);
    } catch (_) {}
  }

  function flashButton(btn, message, failed = false) {
    const original = btn.dataset.originalText || btn.textContent;
    btn.dataset.originalText = original;
    btn.textContent = message;
    btn.disabled = true;
    setTimeout(() => {
      btn.textContent = original;
      btn.disabled = false;
    }, failed ? 2200 : 1100);
  }

  async function promoSingleExists() {
    const handles = (document.documentElement.dataset.promoHandles || '').split(',').filter(Boolean);
    if (!handles.length) return false;
    const cart = await getCart();
    return cart.items.some(i => handles.includes(i.handle));
  }

  $$('.js-add-product').forEach(btn => {
    btn.addEventListener('click', async () => {
      const id = Number(btn.dataset.variantId);
      if (!id) return;
      try {
        if (btn.dataset.promoSingle === 'true') {
          const exists = await promoSingleExists();
          if (exists) {
            alert('The $6.99 offer is limited to one Pick 1 item per order. Choose the Complete Set if you want all three.');
            return;
          }
        }
        btn.disabled = true;
        await addToCart(id, 1);
        await updateCartCount();
        flashButton(btn, 'Added ✓');
      } catch (e) {
        flashButton(btn, 'Try again', true);
      }
    });
  });

  $$('.js-product-form').forEach(form => {
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const btn = $('.rd-btn', form);
      const id = Number($('[name="id"]', form)?.value);
      if (!id) return;
      try {
        if (form.dataset.promoSingle === 'true') {
          const exists = await promoSingleExists();
          if (exists) {
            alert('The $6.99 offer is limited to one Pick 1 item per order. Choose the Complete Set if you want all three.');
            return;
          }
        }
        btn.disabled = true;
        await addToCart(id, 1);
        await updateCartCount();
        window.location.href = '/cart';
      } catch (e) {
        flashButton(btn, 'Try again', true);
      }
    });
  });

  updateCartCount();
})();
